module.exports = __webpack_public_path__ + "img/arrowUp.c5fc6f51.svg";